import { useApi } from '@hero/context';
import type { UseDriverApi, UseDriverListApi } from './types';
import { useInfiniteQueryAPI, useQueryAPI } from '../../utils';

/**
 * Get a single driver by ID from the Driver collection.
 *
 * Hook API: {@link UseDriverApi}
 */
export const useDriverApi: UseDriverApi = (id, apiConfig) => {
  const api = useApi('carrier');
  return useQueryAPI({
    entity: 'driver',
    apiFn: api.drivers.getOne,
    query: undefined,
    singleIdQuery: id,
    apiConfig,
    isEnabled: () => !!id,
  });
};

/**
 * List carrier drivers with pagination. Returns Driver[] from the Driver collection.
 *
 * Hook API: {@link UseDriverListApi}
 */
export const useDriverListApi: UseDriverListApi = (query, apiConfig) => {
  const api = useApi('carrier');
  return useInfiniteQueryAPI({
    entity: 'driver',
    apiFn: api.drivers.getCarrierDrivers,
    query,
    apiConfig,
    isEnabled: () => true,
  });
};
